import { exposedPopulationGraphic } from '@features/lci-report/slides/appendix/projected-visits-methodology/components/exposed-population-graphic';
import { stepText } from '@features/lci-report/slides/appendix/projected-visits-methodology/components/step-text';
import { baseSlide } from '@features/lci-report/slides/appendix/projected-visits-methodology/base-slide';
import { composeSlides, Slide } from '@features/powerpoint';

export const projectedSalesMethodologySlide = (): Slide => {
  return composeSlides(
    baseSlide(),
    stepText(
      '<b>Measure the Full Exposed Population</b>',
      'The campaign match rate multiplier is calculated to measure the ratio between exposed users to InMarket universe and all exposed users',
      {
        x: 3.38,
        y: 1.67,
      }
    ),
    exposedPopulationGraphic({
      position: { x: 4.86, y: 3.52 },
      width: 3,
    })
  );
};
